import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-headlines-index-banner',
    templateUrl: './block-headlines-index-banner.component.html',
})

export class BlockHeadlinesIndexBannerComponent extends BlockAbstractComponent implements OnInit {

}
